// The career, modelled as a git graph.
//
// rail.lines: per lane — 'full' (top→bottom), 'down' (node→bottom), 'up' (top→node),
//             'dashed' (top→bottom, unwritten future), 'tip' (dashed above the node, solid below)
// rail.join:  branch lane merging into this row's node, drawn at the top
// rail.split: branch lane diverging from this row's node, drawn at the bottom
// rail.head:  the commit HEAD points at
export const commits = [
    {
        hash: 'b2c6d43',
        refs: ['security/defcon'],
        period: 'ongoing',
        title: 'DEF CON, every year',
        short: 'DEF CON, every year',
        content:
            'The fun branch. Vegas every summer, and the reason I got into any of this.',
        paths: ['defcon/', 'black-hat/', 'vegas/'],
        changes: [
            'DEF CON every year, and I plan the summer around it',
            'Attended Black Hat USA on scholarship in 2022 and 2024',
            'The idea of being a hacker is what sold me on computer science',
            'Also why I picked Networks and Security as my concentration',
        ],
        rail: { lane: 2, lines: { 0: 'dashed', 1: 'dashed', 2: 'tip' } },
    },
    {
        hash: 'e5b7a90',
        refs: ['mentoring/dps-student'],
        period: 'ongoing',
        title: 'Mentoring, off the clock',
        short: 'Mentoring, off the clock',
        content:
            'Alongside the day job I mentor a Denver Public Schools student learning to code.',
        paths: ['mentoring/', 'python/', 'game-dev/'],
        changes: [
            'Sessions with a Denver Public Schools student, working on his own projects',
            'He built a Doodle Jump clone with me guiding him, his first finished game',
            'Not through work. I do this on my own time.',
        ],
        rail: { lane: 1, lines: { 0: 'dashed', 1: 'tip', 2: 'full' } },
    },
    {
        hash: 'f7a2c19',
        refs: ['HEAD -> main'],
        period: '2024 — now',
        title: 'Backend Software Engineer · bet365',
        short: 'Backend SWE · bet365',
        content:
            'Go microservices and backend APIs for high-volume, low-latency trading systems in Denver.',
        paths: ['go/', 'kafka/', 'docker/', 'ci-cd/'],
        changes: [
            'Build and ship Go microservices behind high-volume trading traffic',
            'Design REST APIs and the service contracts between them',
            'Debug production incidents across distributed services',
            'Built Claude-based agents that automate ticket triage for the team',
            'Ship to production through CI/CD pipelines',
        ],
        rail: { lane: 0, lines: { 0: 'tip', 2: 'full' }, join: 1, head: true },
    },
    {
        hash: 'c3e841d',
        period: '2024 — 2025',
        title: 'Network Support Engineer · Cisco Meraki',
        short: 'Network Support Eng · Meraki',
        content:
            "Returned full-time after the internship and became the team's API subject matter expert.",
        paths: ['networking/', 'meraki-api/', 'automation/', 'linux/'],
        changes: [
            'Resolved 1000+ enterprise network tickets end to end',
            'Became the API SME. I took the Dashboard API and network automation cases other engineers were less comfortable with',
            'Averaged 95%+ CSAT with very few escalations',
            'Helped harden shard-based cloud infrastructure',
            'Packet-level troubleshooting: pcap, routing, VLANs, IPsec tunnels',
        ],
        rail: { lane: 0, lines: { 0: 'full', 2: 'full' } },
    },
    {
        hash: '7e1c04a',
        period: 'May 2024',
        merge: true,
        title: "Merge branch 'csu' into main",
        short: "Merge 'csu' into main",
        content: 'Graduated, and the degree became the day job.',
        rail: { lane: 0, lines: { 0: 'full', 2: 'full' }, split: 1 },
    },
    {
        hash: '9b04f5e',
        refs: ['csu'],
        period: '2020 — 2024',
        title: 'B.S. Computer Science · Colorado State University',
        short: 'B.S. Computer Science · CSU',
        content: 'Concentration in Networks and Security.',
        paths: ['cs455/', 'cs456/', 'cs457/', 'cs370/'],
        changes: [
            'Distributed Systems (CS455), where I built a peer-to-peer overlay network in Java',
            'Modern Cybersecurity (CS456), writing block and stream cipher implementations',
            'Computer Networks (CS457), socket programming from scratch',
            'Operating Systems, Databases, and Algorithms covered the rest of the fundamentals',
        ],
        rail: { lane: 1, lines: { 0: 'full', 1: 'full', 2: 'full' } },
    },
    {
        hash: '4c72f10',
        period: '2022 — 2024',
        title: 'Python TA · IT Lab Technician · Mentor lead',
        short: 'TA · IT Lab · Mentor lead',
        content: 'Three campus roles that overlapped with the degree.',
        paths: ['teaching/', 'it-support/', 'shpe/', 'colorstack/'],
        changes: [
            'TA for intro Python: office hours, labs, and grading',
            'Kept 1000+ campus devices running as an IT lab technician',
            'Led mentoring for first-generation Latinx CS students',
            'Still keep in touch with my mentees today',
            'Active in SHPE and ColorStack',
        ],
        rail: { lane: 1, lines: { 0: 'full', 1: 'full', 2: 'full' } },
    },
    {
        hash: 'd8f120a',
        period: 'summer 2023',
        title: 'Network Support Intern · Cisco Meraki',
        short: 'Network Support Intern · Meraki',
        content: 'Summer internship in Chicago, on the enterprise networking support team.',
        paths: ['networking/', 'vlans/', 'support/'],
        changes: [
            'Shadowed and then owned enterprise networking tickets',
            'Learned VLANs, routing and firewall policy on real customer networks',
            'My first look at infrastructure running at scale',
            'Earned the return offer',
        ],
        rail: { lane: 0, lines: { 0: 'full', 2: 'full' }, join: 1 },
    },
    {
        hash: 'a1d0b27',
        period: 'earlier',
        title: 'Initial commit',
        short: 'Initial commit',
        content: 'Denver, computers, and wanting to be a hacker.',
        paths: ['denver/', 'groundwork/', 'retail/'],
        changes: [
            'Grew up in Denver loving computers and video games',
            'The idea of being a hacker is what sold me on computer science',
            'Environmental work with Groundwork Denver starting at 14',
            'Worked retail before tech, which is where I learned teamwork and how to handle customers',
        ],
        rail: { lane: 0, lines: { 0: 'up' }, join: 2 },
    },
];

export const branches = ['main', 'csu (merged)', 'mentoring/dps-student', 'security/defcon'];

export const findCommit = (query) => {
    const needle = query.trim().toLowerCase();
    return commits.find(
        (commit) =>
            commit.hash === needle ||
            commit.refs?.some((ref) => ref.replace('HEAD -> ', '').toLowerCase() === needle)
    );
};
